export default __webpack_public_path__ + "static/Smackback-1532a829a0d27abc7e572813a485342f.webp";